import { render, staticRenderFns } from "./center_5.vue?vue&type=template&id=17d37b94&scoped=true&"
import script from "./center_5.vue?vue&type=script&lang=js&"
export * from "./center_5.vue?vue&type=script&lang=js&"
import style0 from "./center_5.vue?vue&type=style&index=0&id=17d37b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d37b94",
  null
  
)

export default component.exports